import React from "react"
import { TechnicianDto } from "../../generated"
import TechiniciansStore from "../TechiniciansStore";

interface Props {
    id: number | undefined | null;
    template: (caldaia: TechnicianDto) => JSX.Element | string | number;
}

export const TechnicianViewer = ({ id, template }: Props) => {
    if (!id)
        return null;
    const item = TechiniciansStore.use(id)
    if (item == null) return null;
    return <>{template(item)}</>;
}
export default TechnicianViewer;
export const TechnicianName = (props: { id: number }) => <TechnicianViewer id={props.id} template={t => `${t.firstName} ${t.lastName}`} />